(function () {
  function initVideos(scope) {
    scope.querySelectorAll('[data-ssb-video]').forEach(function (video) {
      if (video.dataset.ssbVideoReady === 'true') return;
      video.dataset.ssbVideoReady = 'true';

      var isMobile = window.matchMedia('(max-width: 749px)').matches;
      var src = (isMobile ? video.dataset.srcMobile : video.dataset.srcPc)
        || video.dataset.srcPc
        || video.dataset.srcMobile;
      if (!src) return;

      var isFirstSlide = video.dataset.firstSlide === 'true';
      var started = false;
      var visible = false;
      var unlocked = !isFirstSlide;
      var mobileFallbackTimer = 0;

      function play() {
        if (!visible || !unlocked) return;
        if (!started) {
          started = true;
          video.src = src;
        }
        var promise = video.play();
        if (promise && typeof promise.catch === 'function') promise.catch(function () {});
      }

      function unlock() {
        unlocked = true;
        play();
      }

      function unlockMobileVideo() {
        window.removeEventListener('pointerdown', unlockMobileVideo);
        window.removeEventListener('keydown', unlockMobileVideo);
        if (mobileFallbackTimer) window.clearTimeout(mobileFallbackTimer);
        unlock();
      }

      function deferFirstVideo() {
        if (!isFirstSlide || unlocked) return;
        if (isMobile) {
          window.addEventListener('pointerdown', unlockMobileVideo, { once: true, passive: true });
          window.addEventListener('keydown', unlockMobileVideo, { once: true });
          mobileFallbackTimer = window.setTimeout(unlockMobileVideo, 12000);
          return;
        }

        var schedule = function () {
          if ('requestIdleCallback' in window) {
            window.requestIdleCallback(unlock, { timeout: 2000 });
          } else {
            window.setTimeout(unlock, 1200);
          }
        };
        if (document.readyState === 'complete') schedule();
        else window.addEventListener('load', schedule, { once: true });
      }

      video.addEventListener('playing', function () {
        video.classList.add('is-playing');
      }, { once: true });
      deferFirstVideo();

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            visible = entry.isIntersecting;
            if (visible) play();
            else if (started) video.pause();
          });
        }, { threshold: 0.25 });
        observer.observe(video);
      } else {
        visible = true;
        play();
      }
    });
  }

  function initDocument() {
    initVideos(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDocument, { once: true });
  } else {
    initDocument();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initVideos(event.target);
  });
})();
